export const isMaintenanceRoute = (pathname: string) =>
  /^\/(?:site-maintenance|maintenance)\/?$/.test(pathname);
